import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索更多内容
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按分类浏览，快速找到你感兴趣的漫画资讯
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer relative"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`继母的朋友们漫画-${cat.name}`}
                  title={`继母的朋友们漫画${cat.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <div className="flex items-center gap-2 text-background-50">
                    <span className="w-8 h-8 flex items-center justify-center">
                      <i className={`${cat.icon} text-xl`}></i>
                    </span>
                    <span className="font-heading font-bold text-lg">{cat.name}</span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{cat.articleCount} 篇文章</span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all duration-200">
                    浏览全部 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}